import {Box, Chip, Stack, Typography} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import {MaterialListItem} from "pages/Material/types";
import Tag from "components/Tag";
import ROUTE from "constants/route";


const MaterialItem = ({id, description, keywords, title, specialView}: MaterialListItem) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMaterialPage = location.pathname.split('/')[1] === ROUTE.MATERIAL;
  const path = specialView && isMaterialPage ? `${id}/first` : id;

  return (
    <Box
      onClick={() => navigate(path)}
      sx={{
        cursor: "pointer",
        borderTop: '1px solid',
        borderColor: 'grey.100',
      }}>
      <Box
        sx={{
          p: 3,
          backgroundColor: "white",
          borderRadius: 5,
          '&:hover': {
            backgroundColor: "grey.400",
          }
        }}
      >
        <Stack direction={'row'} spacing={1} mb={1.5}>
          {keywords?.map((k) => (
            <Tag
              key={`material-${id}-keyword-${k.keyword.id}`}
              title={k.keyword.title}
            />
          ))}
        </Stack>
        <Typography variant={'h5'} sx={{mb: 1}}>{title}</Typography>
        <Typography variant={'p3'} sx={{color: 'grey.200'}}>
          {description}
        </Typography>
      </Box>

    </Box>
  )
}

export default MaterialItem
